<template>
  <div
    class="image-slot"
    :class="[`image-slot--${fit}`, { 'image-slot--fixed': isFixedHeight }]"
    :style="slotStyle"
  >
    <img v-if="src" :src="src" :alt="alt" class="image-slot__img" />
    <div v-else class="image-slot__empty">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="m21 15-5-5L5 21" />
      </svg>
      <span class="image-slot__caption">{{ placeholder }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSlot',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    placeholder: { type: String, default: 'Скриншот' },
    height: { type: String, default: 'auto' },
    fit: {
      type: String,
      default: 'contain',
      validator: (v) => ['contain', 'cover'].includes(v),
    },
  },
  computed: {
    isFixedHeight() {
      return this.height !== 'auto';
    },
    slotStyle() {
      if (!this.isFixedHeight) return null;
      return { height: this.height };
    },
  },
};
</script>

<style scoped>
.image-slot {
  width: 100%;
  background: #f4f5f9;
  overflow: hidden;
  position: relative;
}

.image-slot__img {
  display: block;
}

/* Полный скрин по ширине блока, высота подстраивается */
.image-slot--contain:not(.image-slot--fixed) .image-slot__img {
  width: 100%;
  height: auto;
}

/* Фиксированная рамка (hero) — весь кадр внутри */
.image-slot--fixed {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.image-slot--contain.image-slot--fixed .image-slot__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top center;
}

.image-slot--cover.image-slot--fixed .image-slot__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.image-slot__empty {
  position: absolute;
  inset: 0;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.04);
}

.image-slot__caption {
  max-width: 90%;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
}
</style>
